import React from 'react'
import Overview from '@cmp/templates/OverviewTemplate'
import useSearch from '@src/hooks/useSearch'

export default () => {
  const props = useSearch()
  return <Overview {...props} />
}
